export default __webpack_public_path__ + "img/fEuSVBCZ.19d84e99.svg";